import { render, staticRenderFns } from "./PagosHolder.vue?vue&type=template&id=90da0178&scoped=true"
import script from "./PagosHolder.vue?vue&type=script&lang=js"
export * from "./PagosHolder.vue?vue&type=script&lang=js"
import style0 from "./PagosHolder.vue?vue&type=style&index=0&id=90da0178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da0178",
  null
  
)

export default component.exports